import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import Clipboard from 'clipboard';
import { Svg } from './Svg.js';
import { KeyboardClickable } from './KeyboardClickable.js';
import { SHARE_TOOLS, trackShareToolClick } from './shareToolUtils.js';

/* global dcAnalytics */

export const ClickToCopy = createReactClass({
    propTypes: {
        projectId: PropTypes.number,
        buttonClassName: PropTypes.string,
        indicatorClassName: PropTypes.string,
        useSpan: PropTypes.bool,
        textToCopy: PropTypes.string.isRequired,
        getTrackingLink: PropTypes.func,
        onClickToCopy: PropTypes.func,
        pageName: PropTypes.string,
        children: PropTypes.element,
        className: PropTypes.string,
        essentialsListShare: PropTypes.bool,
    },

    componentDidMount: function () {
        if (this.isClickToCopySupported()) {
            // eslint-disable-next-line react/no-find-dom-node
            this.clipboard = new Clipboard(ReactDOM.findDOMNode(this.holder));
        }
    },

    getInitialState: function () {
        return { clicked: false };
    },

    componentWillUnmount: function () {
        if (this.clipboard) {
            this.clipboard.destroy();
        }
    },

    getTextToCopy: function () {
        if (this.props.getTrackingLink) {
            return decodeURIComponent(this.props.getTrackingLink(this.props.textToCopy, 'directlink', this.props.pageName));
        }
        return this.props.textToCopy;
    },

    shareIcon: function () {
        if (React.Children.count(this.props.children) > 0) {
            return null;
        } else {
            return (
                <Svg icon="ss-link" iconFamily="social-circle"/>
            );
        }
    },

    onClick: function (event) {
        this.setState({ clicked: true });
        if (this.props.onClickToCopy) {
            this.props.onClickToCopy();
        }

        dcAnalytics.trackShareToolClick(this.props.pageName, this.props.textToCopy, 'directlink', this.props.essentialsListShare);
        trackShareToolClick(this.props.projectId, SHARE_TOOLS.DIRECT_LINK);
        event.preventDefault();
    },

    onSpanClick(event) {
        this.onClick(event);
        event.stopPropagation();
    },

    componentDidUpdate: function () {
        if (this.state.clicked) {
            // DOM-modifying calls like setTimeout belong in componentDidUpdate,
            // not directly in an onClick handler; this *will not work* in this.onClick
            setTimeout(this.onClickedTimeout, 2000);
        }
    },

    onClickedTimeout: function () {
        this.setState({ clicked: false });
    },

    isClickToCopySupported: function () {
        return document.queryCommandSupported('copy');
    },

    renderLink() {
        const decoratedTextToCopy = this.getTextToCopy();
        if (this.props.useSpan) {
            return (
                <KeyboardClickable>
                    {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
                    <div className="copy-link" onClick={this.onClick}>
                        <div className={"project-url " + (this.state.clicked ? "copied" : "")}>
                            <Svg icon="ss-link" iconFamily="social-circle"/>
                            <input type="text" className="js-project-url heap-copylink-share" name="project-url"
                                   value={decoratedTextToCopy}/>
                        </div>
                        <a ref={ (holder) => { this.holder = holder; }}
                           data-clipboard-text={decoratedTextToCopy}
                           aria-label="Copy link"
                           className={this.props.className + ' heap-copy-share button-secondary small'}
                           title="Copy project link"
                           data-title="Copy project link"
                           href="#">
                            {this.props.children}
                        </a>
                    </div>
                </KeyboardClickable>
            );
        } else {
            return (
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                <div className="copy-link" onClick={this.onClick}>
                    <div className={"project-url " + (this.state.clicked ? "copied" : "")}>
                        <Svg icon="ss-link" iconFamily="social-circle"/>
                        <input type="text" className="js-project-url heap-copylink-share" name="project-url"
                               value={decoratedTextToCopy}/>
                    </div>
                    <a ref={ (holder) => { this.holder = holder; }}
                       data-clipboard-text={decoratedTextToCopy}
                       aria-label="Copy link"
                       className={this.props.className + ' heap-copy-share button-secondary small'}
                       title="Copy project link"
                       data-title="Copy project link"
                       href="#">
                        {this.props.children}
                    </a>
                </div>
            );
        }
    },

    render: function () {
        if (this.isClickToCopySupported()) {
            return (
                <div className="share-wrapper">
                    {this.renderLink()}
                </div>
            );
        } else {
            return null;
        }
    },

});
